// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import InputmaskController from "./inputmask_controller.js";
application.register("inputmask", InputmaskController);

import CouponsController from "./coupons_controller.js";
application.register("coupons", CouponsController);

import EditorsController from "./editors_controller.js";
application.register("editors", EditorsController);

import FooterController from "./footer_controller.js";
application.register("footer", FooterController);

import PagesController from "./pages_controller.js";
application.register("pages", PagesController);

import PixelsController from "./pixels_controller.js";
application.register("pixels", PixelsController);

import CheckoutsController from "./checkouts_controller.js";
application.register("checkouts", CheckoutsController);

import OrderBumpsController from "./order_bumps_controller.js";
application.register("bumps", OrderBumpsController);

import LandingPagesController from "./landing_pages_controller.js";
application.register("landings", LandingPagesController);

import RegistrationController from "./registration_controller.js";
application.register("registration", RegistrationController);

import PlatformController from "./platform_controller";
application.register("platform", PlatformController);

import Select2Controller from "./select2_controller.js";
application.register("select2", Select2Controller);

import Store__ProductsController from "./store/products_controller.js";
application.register("store--products", Store__ProductsController);

import Store__CheckoutconfigsController from "./store/checkoutconfigs_controller.js";
application.register(
  "store--checkoutconfigs",
  Store__CheckoutconfigsController
);

import StoresController from "./stores_controller.js";
application.register("stores", StoresController);

import GatewayController from "./gateway_controller.js";
application.register("gateway", GatewayController);

import ClientController from "./client_controller.js";
application.register("client", ClientController);

import GatewayClientController from "./gateway_client_controller.js";
application.register("gateway_client", GatewayClientController);

import MasksController from "./masks_controller.js";
application.register("masks", MasksController);

import FormAddressSellerController from "./form_address_seller_controller.js";
application.register("form-address-seller", FormAddressSellerController);

import UpsellOfferController from "./upsell_offer_controller.js";
application.register("upsell_offer", UpsellOfferController);

import Checkout__InternationalController from "./checkout/international_controller.js";
application.register(
  "checkout--international",
  Checkout__InternationalController
);

import CheckoutConfigController from "./checkout_config_controller.js";
application.register("checkout-config", CheckoutConfigController);

import StepsController from "./steps_controller.js";
application.register("steps", StepsController);

import ResetSelectController from "./reset_select_controller.js";
application.register("reset-select", ResetSelectController);
